<template>
  <Modal :visible="visible"
         :style="computedWindowSize"
         class="p-fluid"
         @close="close">
    <template v-slot:header>
      <div class="p-dialog-title">{{ $t('editStaffCommentLabel') }}</div>
    </template>
    <Spinner v-if="dataIsSending" :isSmall="true"/>
    <div v-else class="p-formgrid p-grid p-pt-3">
      <div class="p-field p-col-12 p-sm-12 p-md-12 p-lg-12">
        <LimitedCharsTextarea :submitted="submitted"
                              :rows="5"
                              :required="true"
                              v-model="staffComment"
                              :maxChars="commentMaxChars"
                              :id="'order-staff-comment-modal'"
                              :label="$t('internalCommentLabel')"/>
      </div>
    </div>
    <template #footer>
      <Button :label="$t('Cancel')" icon="pi pi-times" class="p-button-text" @click="close"/>
      <Button :label="$t('Save')" icon="pi pi-check" class="p-button-text" @click="updateComment" />
    </template>
  </Modal>
</template>

<script>
import httpClient from "@/services/http.services";
import formatMixins from "@/mixins/formatMixins";
import showErrorsMixins from "@/mixins/showErrorsMixins";

export default {
  mixins: [ showErrorsMixins, formatMixins ],
  name: 'OrderStaffCommentModal',
  emits: ['close', 'update-staff-comment'],
  props: {
    visible: Boolean,
    item: Object,
  },
  data() {
    return {
      commentMaxChars: 1000,
      dataIsSending: false,
      disableSaveButton: false,
      submitted: false,
      orderId: null,
      staffComment: null,
    }
  },
  watch: {
    visible() {
      if (!this.visible) {
        this.disableSaveButton = false
        this.dataIsSending = false
        this.submitted = false
        this.staffComment = null
      }
    },
    item(value) {
      if (!value) return false
      this.orderId = value.orderId
      this.staffComment = value.comment
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    async updateComment() {
      this.submitted = true
      if (!this.staffComment) {
        return false
      }
      this.disableSaveButton = true
      this.dataIsSending = true
      const obj = {
        order_id: this.orderId,
        staff_comment: this.staffComment,
      }

      try {
        const { status, data } = await httpClient.post('order/update-staff-comment', obj)
        if (status === 200 && data?.success) {
          this.close()
          this.$emit('update-staff-comment', obj)
        } else if (data?.error) {
          this.$toast.add({severity:'error', summary: data.error.summary, detail: data.error.detail, life: this.settings.toastLife});
        }
      } catch(err) {
        this.showError(err)
      } finally {
        this.dataIsSending = false
        this.disableSaveButton = false
      }
    },
  },
  computed: {
    computedWindowSize() {
      if (this.$store.state.mobileLayout && this.$store.state.tabletLayout) {
        return {position: 'relative', top: '-10vh', width: '90%', marginTop: '10px'}
      } else if (!this.$store.state.mobileLayout && this.$store.state.tabletLayout) {
        return {position: 'relative', top: '-10vh', width: '550px', marginTop: '25px'}
      } else {
        return {position: 'relative', top: '-10vh', width: '600px', marginTop: '50px'}
      }
    },
  }
}
</script>